import { GrowthBook } from '@growthbook/growthbook';

let gaClientId = null;
const measurementId = 'G-PMEW5CDHC1';

export const growthbook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: process.env.GROWTHBOOK_CLIENT_KEY || 'sdk-eZpG1PhTX8PM7ky',
  enableDevMode: true,
  subscribeToChanges: true,
  decryptionKey: process.env.GROWTHBOOK_DECRYPTION_KEY || '',
  trackingCallback: (experiment, result) => {
    // TODO: Use your real analytics tracking system when we run experiments on the client side
    console.log('Viewed Experiment', {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
});

export async function setupGrowthbook() {
  const setAttributes = () => {
    growthbook.setAttributes({
      id: gaClientId,
      url: window.location.href,
    });
  };

  const getGaClientId = () => {
    if (window.gtag) {
      gtag('get', measurementId, 'client_id', cId => {
        setGaClientId(cId);
      });
    }
  };

  const setGaClientId = cId => {
    gaClientId = cId;
  };

  if (!!window.gtag) {
    // Google Tag  has already been loaded
    getGaClientId();
    setAttributes();
  } else {
    window.addEventListener('gtm_loaded', function() {
      // Google Tag Manager has been loaded
      getGaClientId();
      setAttributes();
    });
  }

  await growthbook.loadFeatures();
}
